"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerServicePhone = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.CustomerServicePhone = {
    priority: 9,
    label: 'fields.payload.mor_entity_answers.customer_service_phone.label',
    fallbackLabel: 'Customer service phone number',
    tooltip: 'fields.payload.mor_entity_answers.customer_service_phone.tooltip',
    fallbackTooltip: 'You need to include the country code, e.g. +1 541 754 3010',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    mfValidation: {
        pathToValidation: 'base/phoneNumber',
    },
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
